export const MassMessagesSkeleton = () => {
  return (
    <div className="w-full">
      <div className="mt-2 h-[700px] w-full animate-pulse rounded-md bg-skeleton" />
    </div>
  )
}
